export const CLOSE_BUTTON_TEXT = `Закрыть`;
export const MODAL_HEADING_TEXT = `Характеристики товара`;
